module.exports = __webpack_public_path__ + "img/bug-fill.a1803e3f.svg";